import { SelectPicker, InputPicker, Uploader, InputNumber, Pagination, TagPicker, Toggle } from 'rsuite';
import React, { useRef, useState, forwardRef, Component } from 'react';
import { useEffect } from 'react';
import { useImperativeHandle } from 'react';


const ComponentLabeler = (Component, inputSelector = 'input') => {
    return React.forwardRef((props, ref) => {
        const containerRef = useRef();
        useImperativeHandle(ref, () => containerRef.current);
        useEffect(() => {
            const applyLabels = () => {
                const inputs = containerRef.current?.querySelectorAll(inputSelector);
                if (inputs?.length) {
                    inputs?.forEach((input) => {
                        if (!input.getAttribute('aria-label')) {
                            input.setAttribute('aria-label', props.ariaLabel ?? 'Picker');
                        }
                    });
                }
            }
            const observer = new MutationObserver(() => {
                applyLabels();
            })
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    applyLabels();
                    observer.observe(containerRef.current, {
                        childList: true,
                        subtree: true
                    });
                }
            }, 0)
            return () => {
                clearTimeout(timer)
                observer.disconnect();
            }
        }, [])

        return (
            <div ref={containerRef}>
                <Component
                    {...props}
                />
            </div>
        )
    })
}

export const AccessibleInputPicker = ComponentLabeler(InputPicker);
export const AccessibleSelectPicker = ComponentLabeler(SelectPicker);
export const AccessibleUploader = ComponentLabeler(Uploader, 'input[type="file"]');
export const AccessiblePagination = ComponentLabeler(Pagination);
export const AccessibleInputNumber = ComponentLabeler(InputNumber);
export const AccessibleTagPicker = ComponentLabeler(TagPicker);
export const AccessibleToggle = ComponentLabeler(Toggle);
